export default __webpack_public_path__ + "static/media/item-design2.2e01de50.png";